import { put, takeEvery, takeLatest } from "redux-saga/effects";
import { httpGet, httpPut } from "../../services";
import {
  getSecurityHeadersError,
  getSecurityHeadersRequest,
  getSecurityHeadersSuccess,
  saveSecurityHeadersError,
  saveSecurityHeadersRequest,
  saveSecurityHeadersSuccess,
  SecurityHeadersConfig
} from "../features/settings/securityHeaders";

// Go-side fields are nullable (*string/*bool) — coerce nulls to the app's empty/false defaults.
const normalizeConfig = (config: Partial<SecurityHeadersConfig> | null | undefined): SecurityHeadersConfig => ({
  XFrameOptionsHeaderEnabled: !!config?.XFrameOptionsHeaderEnabled,
  XContentTypeOptionsEnabled: !!config?.XContentTypeOptionsEnabled,
  ReferrerPolicyHeader: config?.ReferrerPolicyHeader || "",
  ContentSecurityPolicyHeader: config?.ContentSecurityPolicyHeader || "",
  ContentSecurityPolicyReportOnlyHeader: !!config?.ContentSecurityPolicyReportOnlyHeader,
  ReportingEndpointsHeader: config?.ReportingEndpointsHeader || ""
});

function* getSecurityHeadersHandler() {
  try {
    const response: any = yield httpGet("/security-configuration/response-headers");
    if (response && !response.ErrorCode) {
      yield put(getSecurityHeadersSuccess(normalizeConfig(response)));
    } else {
      throw new Error(response?.Message || response?.Description || "Failed to fetch security header settings.");
    }
  } catch (e: any) {
    yield put(getSecurityHeadersError(e.message || "An error occurred while fetching security header settings."));
  }
}

function* saveSecurityHeadersHandler(action: ReturnType<typeof saveSecurityHeadersRequest>) {
  const { sectionKeys, fields } = action.payload;
  try {
    const response: any = yield httpPut("/security-configuration/response-headers", {}, fields);
    if (response && !response.ErrorCode) {
      yield put(saveSecurityHeadersSuccess({ sectionKeys, config: normalizeConfig(response) }));
    } else {
      throw new Error(response?.Message || response?.Description || "Failed to save security header settings.");
    }
  } catch (e: any) {
    yield put(saveSecurityHeadersError({ sectionKeys, error: e.message || "An error occurred while saving security header settings." }));
  }
}

export function* watchSecurityHeaders() {
  yield takeLatest(getSecurityHeadersRequest.type, getSecurityHeadersHandler);
  yield takeEvery(saveSecurityHeadersRequest.type, saveSecurityHeadersHandler);
}
